import { createAsyncThunk } from '@reduxjs/toolkit';

import { studentProgrammeSet } from '../app/app-slice';
import { currentProgrammeUpdated } from '../programme/programme-slice';

import {
    currentClassroom,
    currentProgramme,
    currentSession,
    getNextLearningObjective,
    lastUncompletedSession,
} from '@api';

import {
    currentClassroomUpdated,
    currentSessionUpdated,
    lastUncompletedSessionUpdated,
    nextLessonUpdated,
} from '@store/session';

/**
 * Load current session to track if we are close to prompting to start a new session
 * Load related classroom when a session is available
 * Load last_uncompleted session to check if an outstanding PSQ session should be prompted
 */
export const loadAppData = createAsyncThunk(
    'init/appDataLoaded',
    async (arg: undefined, { dispatch }) => {
        const programme = await currentProgramme();
        const currSession = await currentSession();
        const lastSession = await lastUncompletedSession();
        const nextLesson = await getNextLearningObjective();

        if (programme) {
            dispatch(
                studentProgrammeSet({
                    programmeTypeReference: programme.programme_type_reference,
                    keyStage: programme.key_stage,
                }),
            );
        }

        dispatch(currentProgrammeUpdated(programme));
        dispatch(currentSessionUpdated(currSession));
        dispatch(lastUncompletedSessionUpdated(lastSession));
        dispatch(nextLessonUpdated(nextLesson));

        if (currSession) {
            const currClassroom = await currentClassroom();
            dispatch(currentClassroomUpdated(currClassroom));
        }
    },
);
